import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth.service';

import * as _ from 'underscore';
import { Subscription } from 'rxjs';
import { KPIService } from './kpi.service';
import { KPIDescriptor } from './model/kpi.descriptor';

/*

*/

@Component({
  selector: 'kpi',
  
  styleUrls: ['./indicator.component.sass'],
  templateUrl: './indicator.component.pug'
})
export class IndicatorComponent implements OnInit, OnDestroy {

  userDataSubscription: Subscription;
  user: any;
  indicators: KPIDescriptor[];
  constructor(
    private authService: AuthService,
    private kpiService: KPIService
  ) {

  }

  ngOnInit(): void {
    this.userDataSubscription = this.authService.getUser().subscribe(
      (userData: any) => {
        this.user = userData;

        if (this.user.profile_id) {
          this.kpiService
          .getIndicators(this.user.profile_id)
          .then(l =>
            this.indicators = l.value.map(u => KPIDescriptor.Map(u))
          );
        }
      });
  }

  ngOnDestroy(): void {
    this.userDataSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/kpi/indicator.component.ts